import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase";

export async function getAllConsoleIntegrations(userAccess) {
  try {
    if (!Array.isArray(userAccess) || userAccess.length === 0) return [];

    const refsCompanys = collection(db, process.env.REACT_APP_COL_COMPANIES);
    const companiesDocs = await getDocs(refsCompanys);
    if (!companiesDocs.docs.length) return [];

    const list = await Promise.all(
      companiesDocs.docs.map(async (d) => {
        let companyData = { id: d.id, ...d.data() };

        if (
          companyData.integrationServicesBicciID &&
          companyData.integrationServicesBicciIsActive
        ) {
          const collRefBicci = collection(
            db,
            process.env.REACT_APP_COL_BICCI_COMPANIES
          );
          const docRefBicci = doc(
            collRefBicci,
            companyData.integrationServicesBicciID
          );
          const docB = await getDoc(docRefBicci);
          if (docB.exists()) {
            companyData = { ...companyData, ...docB.data() };
          }
        }
        return companyData;
      })
    );

    return list;
  } catch (e) {
    console.log("getAllConsoleIntegrations error:", e);
    return [];
  }
}

export async function getConsoleIntegrations(userAccess) {
  try {
    if (
      !Array.isArray(userAccess) ||
      userAccess.length === 0 ||
      userAccess.length >= 10
    )
      return [];

    const refsCompanys = collection(db, process.env.REACT_APP_COL_COMPANIES);
    const qy = query(refsCompanys, where("companyRut", "in", userAccess));
    const companiesDocs = await getDocs(qy);
    if (!companiesDocs.docs.length) return [];

    const list = await Promise.all(
      companiesDocs.docs.map(async (d) => {
        let companyData = { id: d.id, ...d.data() };

        if (
          companyData.integrationServicesBicciID &&
          companyData.integrationServicesBicciIsActive
        ) {
          const collRefBicci = collection(
            db,
            process.env.REACT_APP_COL_BICCI_COMPANIES
          );
          const docRefBicci = doc(
            collRefBicci,
            companyData.integrationServicesBicciID
          );
          const docB = await getDoc(docRefBicci);
          if (docB.exists()) {
            companyData = { ...companyData, ...docB.data() };
          }
        }
        return companyData;
      })
    );

    return list;
  } catch (e) {
    console.log("getConsoleIntegrations error:", e);
    return [];
  }
}
